"use strict";

var _ = require('underscore');
var Backbone = require('backbone');
var ajax = require('ajax');

var RatingsModel = Backbone.Model.extend({

	defaults: function() {
		return {
			/* Parameters */
			client: null,
			api: null,

			/* State */
			startIndex: 0,
			perPage: 1,
			items: [],
			hasMore: true,
			total: null,
		};
	},

	loadMore: function() {
		if ( !this.attributes.hasMore ) return;
		if ( !this.attributes.client || !this.attributes.api ) {
			throw new Error("RatingsModel: Missing client or api parameter");
		}

		console.log("[RatingsModel] Loading more ratings");

		ajax(this.attributes.api, {
			params: {
				client: this.attributes.client,
				start: this.attributes.items.length,
				lang: window.Tramino.lang,
			},
		}).then(function(response) {
			if ( response.status && response.status === "error" ) {
				throw new Error("API call failed: " + response.message);
			}

			if ( !response.total ) return; /* Empty response */

			console.log("[RatingsModel] Response:", response);

			this.set({
				items: _.union(this.attributes.items, response.items),
				total: response.total,
				hasMore: response.total > this.attributes.items.length,
			});
		}.bind(this)).catch(function(e) {
			console.log("Failed to load ratings", e);
		});
	},

});



module.exports = RatingsModel;



// WEBPACK FOOTER //
// /Users/bm/app/code/jsapps/modules/reserva/miniengine/RatingsModel.js